import { NFormTable } from '../../../../Shared/NewForms/NFormTable'
import { NFLookupCurrency } from '../../../../Shared/NewForms/NFlookupCurrency';
import { NFIntInput } from '../../../../Shared/NewForms/NFIntInput';
import { useTranslation } from 'react-i18next';

const ExpenseBankGeneralFunction = () => {
  const { t } = useTranslation();
 

  return (
    <>
      <NFormTable fieldArray={"payments"}>
        <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={500} />
        <NFIntInput title={t("Amount")} fieldName="amount" />
        {/* <NFIntInput title="rate" fieldName="rate" /> */}
        <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
      </NFormTable>
    </>
  )
}

export default ExpenseBankGeneralFunction